import { Link } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import { ArrowUpRight } from "lucide-react";
import { calcMonthly, formatEuro } from "../lib/finance";

export default function BikeCard({ bike, index = 0 }) {
    const { lang, t } = useLang();
    const desc = lang === "es" ? bike.short_desc_es : bike.short_desc_en;
    const isUsed = bike.condition === "used";
    const monthly = calcMonthly(bike.price);

    return (
        <Link
            to={`/motos/${bike.id}`}
            data-testid={`bike-card-${bike.id}`}
            className="group relative block overflow-hidden border border-black/10 bg-[--ls-paper] hover:border-black/30 transition-all hover:-translate-y-1 fade-up"
            style={{ animationDelay: `${index * 0.05}s` }}
        >
            <div className="relative aspect-[4/3] overflow-hidden bg-neutral-100">
                {bike.images?.[0] && (
                    <img
                        src={bike.images[0]}
                        alt={bike.name}
                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                        loading="lazy"
                    />
                )}
                <div className="absolute top-4 left-4">
                    <span
                        className="font-mono text-[10px] uppercase tracking-[0.25em] px-3 py-1.5"
                        style={{
                            background: isUsed ? "var(--ls-terracotta)" : "var(--ls-blue)",
                            color: "white",
                        }}
                    >
                        {isUsed ? t.bike.condition_used : t.bike.condition_new}
                    </span>
                </div>
                <div className="absolute top-4 right-4 font-mono text-xs text-neutral-900 bg-white/85 px-2 py-1">
                    {bike.year}
                </div>
            </div>

            <div className="p-6">
                <p className="text-overline">{bike.category}</p>
                <h3 className="mt-2 font-display text-2xl font-bold tracking-tight text-neutral-900">
                    {bike.name}
                </h3>
                <p className="mt-2 text-sm text-neutral-500 line-clamp-2">{desc}</p>

                <div className="mt-6 flex items-end justify-between border-t border-black/10 pt-4 gap-3">
                    <div>
                        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
                            {t.bike.from_month}
                        </p>
                        <p className="font-display text-3xl font-bold leading-none" style={{ color: "var(--ls-terracotta)" }}>
                            {monthly}<span className="text-xl">{t.bike.per_month}</span>
                        </p>
                        <p className="mt-2 font-mono text-xs text-neutral-500">
                            {t.bike.from} <span className="text-neutral-700">{formatEuro(bike.price)}</span>
                        </p>
                    </div>
                    <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-neutral-600 group-hover:text-neutral-900 shrink-0">
                        {t.bike.view}
                        <ArrowUpRight size={14} />
                    </div>
                </div>
                {isUsed && bike.mileage > 0 && (
                    <p className="mt-3 font-mono text-xs text-neutral-500">
                        {bike.mileage.toLocaleString("es-ES")} {t.bike.mileage}
                    </p>
                )}
            </div>
        </Link>
    );
}
